import { getFullUrl } from 'hubspot-url-utils';
const isAbsolutePath = str => {
  const absolutePathRegExp = new RegExp('^(?:[a-z+]+:)?//', 'i');
  return str.match(absolutePathRegExp);
};
const convertToAbsolutePath = str => {
  if (!str || isAbsolutePath(str)) {
    return str || '';
  }
  if (!str.startsWith('/')) {
    return `${getFullUrl('app')}/${str}`;
  }
  return `${getFullUrl('app')}${str}`;
};
export default convertToAbsolutePath;